import { API_URL } from '../config/config';
import { getRequest } from '../utils/axiosUtils';
import buildQueryParams from '../utils/buildQueryParams';

export const fetchSubscriptionPlanData = async (setPlans) => {
  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/subscription/plan`,
  });

  if (res.status >= 200 && res.status < 300 && res.data) {
    setPlans(res.data?.data?.subscriptions);
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};

export const fetchConversionStatsData = async (filter, setConversionStats) => {
  const { country, state, city, dateRange, gender,utm_payload, isBot } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    // dateRange,
    utm_payload,
    isBot
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/users/conversion?${queryParams}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    const totalUsersCount = res.data.data.totalUsersCount || 0;
    const completedProfiles = res.data.data.completedProfiles || 0;
    const profileCompletionRate = res.data.data.profileCompletionRate || 0;
    const totalSubscribedUsers = res.data.data.totalSubscribedUsers || 0;
    const subscribedUsersPercent = res.data.data.subscribedUsersPercent || 0;

    const metricsDataObject = [
      {
        title: '100% Profile Completion Rate',
        value: `${completedProfiles}`,
        change: `${profileCompletionRate}%`,
        total: `${totalUsersCount}`,
        description: 'of users have completed profiles',
        details: 'Percentage of users who have completed their profile.',
      },
      {
        title: 'Free to Paid User Conversion',
        value: `${totalSubscribedUsers}`,
        change: `${subscribedUsersPercent}%`,
        total: `${totalUsersCount}`,
        description: 'of free users converted to premium',
        details: 'Percentage of free users upgrading to premium plans.',
      },
    ];

    setConversionStats(metricsDataObject);
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};

export const fetchSubscriptionData = async (filter, setSubsctiptionData) => {
  const { country, state, city, dateRange, gender,utm_payload,duration, isBot } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
    isBot,
    duration
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/subscription?${queryParams}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    setSubsctiptionData(res.data.data);
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};

export const fetchRevenueStat = async (filter, setPlans) => {
  const { country, state, city,gender, dateRange, utm_payload,isBot,duration } = filter;
   const queryParams = buildQueryParams({country, state, city,gender, dateRange, utm_payload,isBot});
  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/revenue?${queryParams}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    setPlans(res.data.data);
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};

export const fetchRevenueData = async (filter, setPlans) => {
  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/revenue/weekly`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    setPlans(res.data.data);
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};

export const fetchSubscriberGraphData = async (filter, setData) => {
  const { country, state, city, dateRange, gender,utm_payload } = filter;

  const queryParams = buildQueryParams({
    country,
    state,
    city,
    gender,
    dateRange,
    utm_payload,
  });

  const res = await getRequest({
    url: `${API_URL}/admin/analytics/stat/subscription/data?${queryParams}`,
  });
  if(!res) return
  if (res.status >= 200 && res.status < 300 && res.data) {
    setData(res.data.data);
  } else {
    throw new Error(`Unexpected response code: ${res.status}`);
  }
};
